import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CheckForCheckboxProps = IconComponentBaseProps;

export const CheckForCheckbox = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: CheckForCheckboxProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_8313_16460"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8313_16460)">
        <path
          d="M9.55002 15.15L18.025 6.675C18.225 6.475 18.4584 6.375 18.725 6.375C18.9917 6.375 19.225 6.475 19.425 6.675C19.625 6.875 19.725 7.1125 19.725 7.3875C19.725 7.6625 19.625 7.9 19.425 8.1L10.25 17.3C10.05 17.5 9.81669 17.6 9.55002 17.6C9.28336 17.6 9.05002 17.5 8.85002 17.3L4.55002 13C4.35002 12.8 4.25419 12.5625 4.26252 12.2875C4.27086 12.0125 4.37502 11.775 4.57502 11.575C4.77502 11.375 5.01252 11.275 5.28752 11.275C5.56252 11.275 5.80002 11.375 6.00002 11.575L9.55002 15.15Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
